/**
 * Description:
 * this is a class that is created to facilitate to migrate away from the GptConfigData.json to just using inline
 * html code to define adslots.
 *
 * Sample of how to define a new ad slot:
 *
    <adslot
        data-g-ad-format="panorama,wide_skyscraper"   // separate multiple formats with a comma
        data-g-ad-device="desktop"                    // mobile,tablet,desktop
        data-g-ad-position="top-desktop" />             // match this towards the "pos" in DFP
 *
 */
import almostRandom from '../../../../utils/almost-random';

class AdSlot {

    /**     
     * @param {string} adFormats - accepts one or more ',' separated of: panorama, wide_skyscraper, half_page, medium_rectangle, mobile_rectangle, leaderboard
     * @param {string} position 
     * @param {string} device - accepts one of: mobile, tablet, desktop, desktop-lg
     */
    constructor(adFormats, position, device) {

        if (!adFormats || !position || !device) {
            console.warn(
                'Constructor is missing some of the required arguments: adFormats, position, device',
                'background:red; color:white; font-size:14px;'
            );
        }


        this.collapseIfEmpty = true;
        this.lazyLoading = false;
        this.position = position;
        this.device = device;

        this.adSizes = [];
        adFormats.split(',').forEach(adFormat => {
            this.adSizes = this.adSizes.concat(this._getAdSizes(adFormat));
        });

        // this id should be unique on a page, it's used by the google-ads-loader.js script
        this.htmlDomId = `${this.position}-${almostRandom.get()}`;
    }

    _getAdSizes(adFormat) {
        const viewPortMapping = {
            'panorama': [[980, 300], [980, 240], [980, 160], [980, 120]],
            'wide_skyscraper': [[160, 600]],
            'half_page': [[300, 600]],
            'medium_rectangle': [[300, 250]],
            'mobile_rectangle': [[320, 320]],
            'leaderboard': [[728, 90]]
        };
        return viewPortMapping[adFormat];
    }

    /**
     * @returns array with first elements: 
     * - min width
     * - max width
     */
    _getDeviceViewPortSize() {
        let deviceViewportMappings = {
            'mobile': [0, 450],
            'tablet': [767, 980],
            'desktop': [1250, 0],
            'desktop-lg': [1600, 0]
        };
        return deviceViewportMappings[this.device];
    }

    getGptSlotObject() {
        let [minWidth, maxWidth] = this._getDeviceViewPortSize();
        let viewportSizeMappings = [];
        viewportSizeMappings.push({
            viewportSize: { width: minWidth, height: 0 },
            viewportWidth: minWidth,
            viewportHeight: 0,
            slotSizes: this.adSizes.map(size => ({ width: size[0], height: size[1] }))
        });

        if (maxWidth > 0) {
            viewportSizeMappings.push({
                viewportSize: { width: maxWidth, height: 0 },
                viewportWidth: maxWidth,
                viewportHeight: 0,
                slotSizes: []
            });
        }

        if (0 < minWidth) {
            viewportSizeMappings.push({
                viewportSize: { width: 0, height: 0 },
                viewportWidth: 0,
                viewportHeight: 0,
                slotSizes: []
            });
        }

        return {
            'htmlDomId': this.htmlDomId,
            'viewportSizeMappings': viewportSizeMappings,
            'position': this.position,
            'collapseIfEmpty': this.collapseIfEmpty,
            'lazyLoading': this.lazyLoading,
            'customTargetingParameters': {
                'pos': this.position
            }
        };
    }
}

export default AdSlot;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/ads/ad-slot.js